import axiosInstance from "../helper/axiosIntanceApiZalo";
import axios from '../helper/axiosIntance';
import axiosCheckSip from "../helper/axiosCheckSip";
import { normalizeStringInObject } from "../utils/normalize";

function getFormData(object) {
    const formData = new FormData();
    if(object){
        Object.keys(object).forEach(key => formData.append(key, object[key]));
    }
    return formData;
}
const find_call_history = (params)=>{
    return axios.post('/pbx/api/findCallHistory', normalizeStringInObject(params));
}

const find_call_history_quick = (params)=>{
    return axios.post('/pbx/api/findCallHistory', getFormData(normalizeStringInObject(params)));
}

const count_call_history = (params)=>{
    return axios.post('/pbx/api/countTotalCallLog', getFormData(normalizeStringInObject(params)));
}

const count_call_history_status = (params)=>{
    return axios.post('/pbx/api/countTotalCallLogStatus', getFormData(normalizeStringInObject(params)));
}

const find_record = (params)=>{
    return axios.post('/pbx/api/findRecord', getFormData(normalizeStringInObject(params)));
}

const download_record = (params)=>{
    return axios.post('/pbx/api/fdownload', normalizeStringInObject(params));
}
const check_sip = (params)=>{
    return axiosCheckSip.post('api/key_auth', normalizeStringInObject(params));
}
const find_sip_config_history = (params)=>{
    return axios.post('/pbx/api/findSipConfigCallHistory', normalizeStringInObject(params));
}
const find_did_of_user = (params)=>{
    return axios.post('/pbx/api/findDidOfUser', normalizeStringInObject(params));
}
const find_sip_config = (params)=>{
    return axios.post('/pbx/api/findSipConfig', normalizeStringInObject(params));
}
const find_sip_config_selected = (params)=>{
    return axios.post('/pbx/api/findSipConfigSelected', normalizeStringInObject(params));
}
const find_range_sip_config = (params)=>{
    return axios.post('/pbx/api/findRangeSipConfig', normalizeStringInObject(params));
}
const update_sip_config = (params)=>{
    return axios.post('/pbx/api/updateConfigSip', normalizeStringInObject(params));
}
const disconnect_pbx = (params)=>{
    return axios.post('/pbx/api/disconnectPBX', normalizeStringInObject(params));
}
const get_private_list = (params)=>{
    return axios.post('/privatecustomer/api/getListCustomer', normalizeStringInObject(params));
}
const add_time_expires = (params)=>{
    return axios.post('/privatecustomer/api/addTime', normalizeStringInObject(params));
}
const destroy_expires = (params)=>{
    return axios.post('/privatecustomer/api/killTimeExpires', normalizeStringInObject(params));
}
const downloadCallHistory = (params)=>{
    return axios.post('/pbx/api/downloadCallHistory', normalizeStringInObject(params),{ responseType: 'blob' });
}
const showPasswordExt = (params)=>{
    return axios.post('/pbx/api/showPassExtension', normalizeStringInObject(params));
}
export default {
    find_call_history,
    find_record,
    download_record,
    count_call_history,
    count_call_history_status,
    check_sip,
    find_sip_config_history,
    find_did_of_user,
    find_sip_config,
    update_sip_config,
    disconnect_pbx,
    find_sip_config_selected,
    find_range_sip_config,
    find_call_history_quick,
    get_private_list,
    add_time_expires,
    destroy_expires,
    downloadCallHistory,
    showPasswordExt
}
